export const BUTTON_TEXT = 'Add to Bag';
export const WISHLIST_BUTTON_TEXT = 'Add to Wishlist';
export const THUMBNAIL_COUNT = 4;
